import { Loadable } from '../../Loadable';

export const AsyncAddDrinkOption = Loadable(() => import('./Add'));
export const AsyncEditDrinkOption = Loadable(() => import('./Edit'));
export const AsyncDrinkOptions = Loadable(() => import('./List'));
